module.exports = __webpack_public_path__ + "static/media/list-asset.f818422c.png";